import Backbone from 'backbone';
import rivets from 'rivets';
import { reload } from '../../../validation/validation-controller';
import BusinessSpecificBaseView from '../../../layout/b2b/businessSpecificBaseView';
import BusinessSpecificFormModel from '../../../layout/b2b/businessSpecificFormModel';
import RemoteEmailValidation from '../../../layout/remoteEmailValidation';

export default BusinessSpecificBaseView.extend({
  selectors: {
    legalForm: '.js-company-legal-form select',
    registrationNumberWrapper: '.js-registration-number',
    companyHolderWrapper: '.js-registration-company-holder',
    combinedVatFieldsInput: '.js-combined-vat-fields',
    vatNumberField: '.js-company-vat-number input',
    hiddenClass: 'is-hidden'
  },

  initialize: function() {
    this.model = new BusinessSpecificFormModel();

    this.$registrationNumber = this.$el
      .find(this.selectors.registrationNumberWrapper)
      .find('input');
    this.$companyHolder = this.$el
      .find(this.selectors.companyHolderWrapper)
      .find('input');
    this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);

    this.$registrationNumber = this.$el
      .find(this.selectors.registrationNumberWrapper)
      .find('input');
    this.$companyHolder = this.$el
      .find(this.selectors.companyHolderWrapper)
      .find('input');
    this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);

    this.initializeModel(this.model);
    this.bindEvents(this.model);

    reload();

    this.triggerChanges(this.model);
    this.setupRivetsBindings();

    var $email = this.$('[name="email"]');

    if ($email.length > 0) {
      new RemoteEmailValidation({
        el: $email
      });
    }
  },

  setupRivetsBindings: function() {
    rivets.bind(this.$el, {
      businessCustomer: this.model
    });
  },

  destroy: function() {
    this.unbindEvents(this.model);
    Backbone.View.prototype.remove.call(this);
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/profile/PersonalInformationBusinessCustomerView.js
 **/